import React, {useState} from 'react';
import s from '../TableCommonDirectory/TableElements/TableElements.module.css';
import ApproveAskPopup from '../ApproveAskPopup/ApproveAskPopup';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';

export type ActionType =
	| 'delete'
	| 'edit'
	| 'print'
	| 'approve'
	| 'info'
	| 'pay'
	| 'reject'
	| 'confirm'
	| 'receive'
	| 'move'
	| 'gift';

export type ActionConfig = {
	type: ActionType;
	icon: string;
	label: string;
	requiresConfirmation?: boolean;
	confirmText?: string;
	disabled?: (status: string, type?: string) => boolean;
	handler: (orderId: number) => Promise<void> | void;
};
type Props = {
	orderId: number;
	orderType?: string;
	orderStatus: string;
	actions: ActionConfig[];
};
const TableButtonsActions: React.FC<Props> = ({
	orderId,
	orderType,
	orderStatus,
	actions,
}) => {
	const {t} = useTranslation();
	const [activeConfirm, setActiveConfirm] = useState<ActionType | null>(null);

	const handleConfirm = async () => {
		const action = actions.find((a) => a.type === activeConfirm);
		if (action) {
			try {
				await action.handler(orderId);
			} catch (e) {
				toast.error(t('Помилка'));
			}
		}
		setActiveConfirm(null);
	};

	const handleClick = (action: ActionConfig, e: React.MouseEvent) => {
		e.stopPropagation(); // Останавливаем всплытие события
		e.preventDefault(); // Предотвращаем стандартное поведение
		
		const isDisabled =
			orderType !== undefined
				? action.disabled?.(orderStatus, orderType)
				: action.disabled?.(orderStatus);

		if (isDisabled) return;

		if (action.requiresConfirmation) {
			setActiveConfirm && setActiveConfirm(action.type);
		} else {
			action.handler(orderId);
		}
	};
	return (
		<>
			<ul
				className={`${s.productRowcolumn} ${s.actionColumn} shopping__item shopping__action`}
				onClick={(e) => e.stopPropagation()}
			>
				{actions.map((action) => {
					const isDisabled = action.disabled?.(orderStatus, orderType) ?? false;
					return (
						<li key={action.type} onClick={(e) => e.stopPropagation()}>
							<button
								className={`shopping__icon ${isDisabled ? s.disabled : ''}`}
								disabled={isDisabled}
								onClick={(e) => handleClick(action, e)}
								{...(isDisabled ? {} : {title: action.label})}
							>
								<img src={action.icon} alt={action.label} />
							</button>
						</li>
					);
				})}
			</ul>
			{activeConfirm && (
				<ApproveAskPopup
					approvedCallback={handleConfirm}
					canceledCallback={() => setActiveConfirm(null)}
					questionText={
						actions.find((a) => a.type === activeConfirm)?.confirmText
					}
				/>
			)}
		</>
	);
};

export default TableButtonsActions;
